<script lang="ts">
  import type { SerializedPlace } from '../types'

  let { place }: { place: SerializedPlace } = $props()
</script>

<address class="place-address">
  <span class="place-address-name">{place.name}</span>
  <!-- Isolated, so right-to-left pages keep the German order of e.g. "86150 Augsburg". -->
  <span class="place-address-line"><bdi>{place.street}</bdi></span>
  <span class="place-address-line"><bdi>{place.postalCode} {place.city}</bdi></span>
</address>

<style>
  .place-address {
    min-width: 0;
    font-style: normal;
    font-size: var(--font-size-4);
    line-height: var(--line-height-3);
    color: var(--color-text);
  }

  .place-address-name {
    display: block;
    font-weight: var(--font-weight-3);
  }

  .place-address-line {
    display: block;
    color: var(--color-text-muted);
  }
</style>
